import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_QUESTIONNAIRE_DETAIL = 'GET_QUESTIONNAIRE_DETAIL';
export const GET_QUESTIONNAIRE_DETAIL_SUCCESS =
  'GET_QUESTIONNAIRE_DETAIL_SUCCESS';
export const GET_QUESTIONNAIRE_DETAIL_FAILURE =
  'GET_QUESTIONNAIRE_DETAIL_FAILURE';

// Action Creators
export const getQuestionnaireDetail = () => ({
  type: GET_QUESTIONNAIRE_DETAIL,
});

export const getQuestionnaireDetailSuccess = (users) => ({
  type: GET_QUESTIONNAIRE_DETAIL_SUCCESS,
  payload: users,
});

export const getQuestionnaireDetailFailure = (error) => ({
  type: GET_QUESTIONNAIRE_DETAIL_FAILURE,
  payload: error,
});

// Thunk Function
export const getQuestionnaireDetailData = (external, id) => {
  return async (dispatch) => {
    dispatch(getQuestionnaireDetail());
    try {
      const response = await getMethodWithToken(
        url?.getQestionnaireDetail + id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getQuestionnaireDetailSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getQuestionnaireDetailFailure(error?.message));
    }
  };
};
